var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("hr", { staticClass: "my-4" }),
    _vm._v(" "),
    _c("div", { staticClass: "row h-100" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "col-11" }, [
        _vm._v(_vm._s(_vm.$t("message.subscription.subscription_benefit01")))
      ])
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "my-4" }),
    _vm._v(" "),
    _c("div", { staticClass: "row h-100" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "col-11" }, [
        _vm._v(_vm._s(_vm.$t("message.subscription.subscription_benefit02")))
      ])
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "my-4" }),
    _vm._v(" "),
    _c("div", { staticClass: "row h-100" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "col-11" }, [
        _vm._v(_vm._s(_vm.$t("message.subscription.subscription_benefit03")))
      ])
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "my-4" }),
    _vm._v(" "),
    _c("div", { staticClass: "mb-2 text-remark" }, [
      _c("span", { staticClass: "text-pink" }, [
        _vm._v(_vm._s(_vm.$t("message.my_reservations.remark")) + ":")
      ]),
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("message.subscription.subscription_remark")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn btn-outline-info btn-block",
        attrs: { href: "https://line.me/R/ti/p/@BeNeat", target: "_blank" }
      },
      [_vm._v(_vm._s(_vm.$t("message.subscription.contact_admin")))]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-4 text-center" }, [
      _c("img", {
        attrs: { src: "/static/img/ic_calendar.svg", alt: "", width: "180" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1 my-auto subscription-list" }, [
      _c("i", { staticClass: "far fa-check-circle -status-accepted fa-lg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1 my-auto subscription-list" }, [
      _c("i", { staticClass: "far fa-check-circle -status-accepted fa-lg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1 my-auto subscription-list" }, [
      _c("i", { staticClass: "far fa-check-circle -status-accepted fa-lg" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cea317e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cea317e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/SubscriptionDetail.vue
// module id = 1503
// module chunks = 0